import React ,{useRef ,useEffect}from 'react';
import './purchase-invoice-list.scss'
import DynamicInputList from '../software-dynamic-version-3/list-input-v-3';
import PurchaseInvoiceAdd from './purchase-invoice-add';
import PurchaseInvoiceService from './purchase-invoice.service';
import moment from 'moment'
import securityService from '../security/security.service';
 
const PurchaseInvoiceList = (props) => {

  let columns = [
    { field: "PurchaseInvoiceID", headerText: 'ID', width: '160px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "CompanyName", headerText: 'Company Name', width: '160px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "CompanyID", headerText: 'Company ID', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "PurchaseInvoiceDate", headerText: 'Invoice Date', width: '150px', textAlign: 'center', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "CostCenter", headerText: 'Cost Center', width: '150px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "CostCenterID", headerText: 'Cost Center ID', width: '120px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "AccountTitleVendor", headerText: 'Vendor Account Title', width: '180px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "AccountIDVendor", headerText: 'Vendor Account ID', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "AccountTitleExpense", headerText: 'Expense Account Title', width: '180px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    // { field: "AccountIDExpense", headerText: 'Expense Account ID', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "PaymentDays", headerText: 'Payment Days', width: '130px', textAlign: 'right', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "ReferenceInvoiceNo", headerText: 'Reference Invoice No', width: '180px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "TRNNo", headerText: 'TRN No', width: '140px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "PreparedBy", headerText: 'Prepared By', width: '140px', textAlign: 'left', headerTextAlign: 'center', other: [{ allowEditing: false }] },
    { field: "TotalPurchaseQuantity", headerText: 'Total Quantity', width: '130px', textAlign: 'right', headerTextAlign: 'center', other:[{format:'n2'}] },
    { field: "TotalPurchaseAmount", headerText: 'Purchase Amount', width: '150px', textAlign: 'right', headerTextAlign: 'center', other:[{format:'n2'}] },
    { field: "TotalTaxAmount", headerText: 'Tax Amount', width: '130px', textAlign: 'right', headerTextAlign: 'center', other:[{format:'n2'}] },
    { field: "TotalAmount", headerText: 'Total Amount', width: '150px', textAlign: 'right', headerTextAlign: 'center', other:[{format:'n2'}] }
  ];
  

  const listActionComplete = (grid , args ,getListService ,selectedRow )=>{
    console.log("args",args )
    console.log("getListService",getListService )
    console.log("selectedRow",selectedRow )
    if (args.requestType === 'beginEdit' || args.requestType === 'add') {
      }
    if (args.requestType == 'save' || args.requestType == 'cancel' ) {
      setTimeout(()=>{getListService()},560)
    }
if(args.requestType == 'save' && args.data.PurchaseInvoiceID){
      let data ={
        CompanyID:args.data.CompanyID,
        PurchaseInvoiceID : args.data.PurchaseInvoiceID,
        PurchaseInvoiceDate:moment(args.data.PurchaseInvoiceDate).format('DD-MMM-YY'),
        CostCenterID:args.data.CostCenterID,
        AccountIDVendor:args.data.AccountIDVendor,
        AccountIDExpense:args.data.AccountIDExpense,
        PaymentDays:args.data.PaymentDays,
        ReferenceInvoiceNo:args.data.ReferenceInvoiceNo,
        TRNNo:args.data.TRNNo,
        PreparedBy:args.data.PreparedBy,
        Description:args.data.Description,
        SaleQuantity:args.data.SaleQuantity,
        SaleRate:args.data.SaleRate,
        SaleAmount:args.data.SaleAmount,
        TaxPercent:args.data.TaxPercent,
        TaxAmount:args.data.TaxAmount,
        TotalAmount:args.data.TotalAmount,
        PurchaseInvoiceDetailID:args.data.PurchaseInvoiceDetailID
      }
      console.log("data",data)
      PurchaseInvoiceService.editPurchaseInvoice(data).then((res)=>{
        console.log(res)
        // setTimeout(()=>{getListService()},560)
      })
    }
  }
  let allowTemplate = false
  let allowDataBound = false
  let  isDialog = props.IsDialog == true ? true : false
  let  allowGridSum = true
  let ListSecurity=  'Purchase Invoice'
  let AddSecurity=  'Purchase Invoice'
  let EditSecurity=  'Purchase Invoice'
  let DeleteSecurity=  'Purchase Invoice'

  let toolbarOptions = 'All'
  const toolbarClicking =  async (args)=>{
    console.log(args)
   }
   // Defines the 'Descending' | 'Ascending'
   //  @default 'Descending'
  let DefaultSortedColumnSort ='Descending';
  let listDelete =  [{ TableName:['PurchaseInvoice_Detail','PurchaseInvoice'] ,TableID:['PurchaseInvoiceID'],  }]
  let deleteType = 'Hard'
  let filterColumns = [];
  let groupColumns = [];
  let gridEditSettingMode = 'Dialog';
  let gridEditSettingHeaderTemplate = '<p></p>';
  let gridSumColumns = ['TotalAmount'];

  const getPurchaseInvoiceForList = async ()=>{
    return PurchaseInvoiceService.getForList()
  }

  return (
      <DynamicInputList
      Id='PurchaseInvoice'
      ListTitle={`Purchase Invoice - LIST`}
      ColumnsList={columns}
      GridDataSource= {[
                  {
                      DataSourceType: 'Function',
                      DataSource:  ()=> getPurchaseInvoiceForList()
                      }]}
      DefaultSortedColumnName={'PurchaseInvoiceID'}
      GridDialog={[
          {
              DialogType:'Self',
              Dialog:<PurchaseInvoiceAdd  GridID = {`PurchaseInvoice`} />
              }
      ]}
      ListActionComplete={listActionComplete}
      ToolbarClicking ={toolbarClicking}
      AllowTemplate={allowTemplate}
      ToolbarOption={toolbarOptions}
      AllowDataBound={allowDataBound}
      ListSecurity={ListSecurity}
      AddSecurity={AddSecurity}
      EditSecurity={EditSecurity}
      DeleteSecurity={DeleteSecurity}
      DefaultSortedColumnSort={DefaultSortedColumnSort}
      FilterColumns={filterColumns}
      ListDelete={listDelete}
      DeleteType={deleteType}
      GridEditSettingMode={gridEditSettingMode}
      GridEditSettingHeaderTemplate={gridEditSettingHeaderTemplate}
      // GridSumColumns={gridSumColumns}
      AllowGridSum={allowGridSum}
      IsDialog={isDialog}
      // ...other props as in export-sale-invoice-list.js
    />
  );
};

export default PurchaseInvoiceList;
